import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import plusIcon from '../../assets/track-icon/info-icons/plus-icon-black.svg';
import dashIcon from '../../assets/track-icon/info-icons/dash-icon-black.svg';
import calanderIcon from '../../assets/track-icon/info-icons/calander-icon.svg';
import penArrowIcon from '../../assets/track-icon/info-icons/pen-arrow-icon.svg';
import questionAnswerIcon from '../../assets/track-icon/info-icons/question-answer-icon.svg';
import gptIcon from '../../assets/track-icon/info-icons/gpt-icon.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: 'column'
        },
        width: '100%',
    },
    tracksInfoContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    header: {
        marginBottom: '2rem'
    },
    headerPills: {
        [theme.breakpoints.down("md")]: {
            width: "100%",
        },
        display: 'flex',
        justifyContent: 'baseline',
        gap: '1rem',
        background: '#FFFFFF',
        borderRadius: '5px',
        cursor: 'pointer',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        padding: '1rem',
        width: "90%",
        '& img': {
            width: '15px'
        },
        '& ul': {
            maxHeight: '15rem',
            overflow: 'auto',
            paddingLeft: '1.5rem'
        },
        '& li::marker': {
            fontSize: '1.5rem',
            color: '#4285F4',
        },
        '& li': {
            margin: '0.1rem 0',
            color: 'black',
        }
    },
    mainBodyWithTrackDetails: {
        flexGrow: '1',
        '& div': {
            display: 'flex',
            gap: '0.5rem',
        },
        '& > div': {
            [theme.breakpoints.down("sm")]: {
                gap: '1rem !important',
            },
            gap: '2rem !important',
            marginTop: '0.5rem'
        },
    },
    highlitedText: {
        color: '#4285F4',
        fontWeight: 'bold',
    },
    customScroll: {
        '&::-webkit-scrollbar': {
            width: '5px',
        },
        '&:hover::-webkit-scrollbar-thumb': {
            borderRadius: '5px',
            background: '#707070',
        },
        '&:hover::-webkit-scrollbar-track': {
            borderRadius: '5px',
            boxShadow: 'inset 0 0 3px grey',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#8b8b8b',
        },
    }
}))

const Syllabus = ({ categories }) => {

    const classes = useStyles();
    const [openedPills, setOpenedPills] = useState({})

    return (
        <section className={classes.root}>
            <div className={classes.header}>
                <h1>Syllabus</h1>
                <p>
                    <h3>Your way to secure high-paying FAANG employment opportunities with an average annual salary of <span className={classes.highlitedText}>$180,000</span></h3>
                </p>
            </div>
            <div className={classes.tracksInfoContainer}>
                {categories.map((val, idx) => (
                    <div
                        className={classes.headerPills} key={val.categoryName + '' + idx}
                        onClick={() => setOpenedPills((prev) => ({ ...prev, [idx]: !prev[idx] }))}
                    >
                        <div><span className={classes.highlitedText}>{`0${idx + 1}`}</span></div>
                        <div className={classes.mainBodyWithTrackDetails}>
                            <h4>{val.categoryName}</h4>
                            <div>
                                {val.classroomSessions && <div className={classes.textWithImage}>
                                    <img src={calanderIcon} />
                                    <span>{val.classroomSessions}</span>
                                </div>}
                                {val.oneOnOneSessions && <div className={classes.textWithImage}>
                                    <img src={penArrowIcon} />
                                    <span>1-on-1 session</span>
                                </div>}
                            </div>
                            {openedPills[idx] &&
                                <>
                                    <ul className={classes.customScroll}>
                                        {categories[idx].capabilities.map((infoPoint, idx) => (
                                            <>
                                                <li key={infoPoint.capabilityText + idx + "points"}>
                                                    <span>{infoPoint.capabilityText}</span>
                                                </li>
                                                <span key={infoPoint.capabilityText + idx + "description"}
                                                    dangerouslySetInnerHTML={{ __html: infoPoint.capabilityDescription }}
                                                />
                                            </>
                                        ))}
                                    </ul>
                                    {val.oneOnOneSessions && <div>
                                        <img src={questionAnswerIcon} ></img>
                                        <h4>Mock interviews with 1-on-1 session and interview retrospectives</h4>
                                    </div>}
                                    <div>
                                        <img src={gptIcon} ></img>
                                        <h4>Chat GPT integration</h4>
                                    </div>
                                </>}
                        </div>
                        <div><img src={openedPills[idx] ? dashIcon : plusIcon} /></div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Syllabus;